export default import.meta.ROLLDOWN_FILE_URL_Q7AGgfMS2umt67I1yX1$9g